import { Directive, Input, TemplateRef, ViewContainerRef, OnInit, OnChanges } from '@angular/core';
import { DataService } from '../services/data.service';
import { PermessionType} from '../models/enumeration-list.model';

@Directive({
  standalone: true,
  selector: '[appCheckPermission]',
})
export class CheckPermissionDirective implements  OnChanges {
  @Input('appCheckPermission') permissionObj!: { module: string; action: PermessionType  };

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private dataService: DataService
  ) {}

  

  public ngOnChanges(): void {
    this.updateView();
  }

  private updateView(): void {
    const { module, action } = this.permissionObj;
    let hasPermission =this.dataService.hasPermessionForSpecificModule(module,action)
      if (hasPermission) {
        this.viewContainer.createEmbeddedView(this.templateRef);
      } else {
        this.viewContainer.clear();
      }
    } 
  }

